(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mawj-article-premium"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-copy-link]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        navigator.clipboard.writeText(window.location.href).then(function() {
          btn.classList.add('is-copied');
          setTimeout(function() { btn.classList.remove('is-copied'); }, 1600);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mawj-before-after-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mawj-ba]').forEach(function (root) {
      var afterLayer = root.querySelector('[data-after]');
      var handle = root.querySelector('[data-handle]');
      var dragging = false;
      var rect;
      function setPos(clientX) {
        if (!rect) rect = root.getBoundingClientRect();
        var x = clientX - rect.left;
        var pct = Math.max(2, Math.min(98, (x / rect.width) * 100));
        var dir = getComputedStyle(root).direction === 'rtl';
        // In RTL we still want the slider to move "intuitively" with drag direction;
        // clip-path inset from logical "start" matches LTR/RTL automatically with inset-inline.
        // Using physical left/right for safety:
        // RTL: after layer is on LEFT, clip from RIGHT so boundary aligns with handle
        // LTR: after layer is on RIGHT, clip from LEFT
        afterLayer.style.clipPath = dir
          ? 'inset(0 ' + (100 - pct) + '% 0 0)'
          : 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
      }
      function start(e) {
        dragging = true;
        rect = root.getBoundingClientRect();
        document.body.style.cursor = 'ew-resize';
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(x);
      }
      function move(e) {
        if (!dragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(x);
      }
      function end() {
        dragging = false;
        rect = null;
        document.body.style.cursor = '';
      }
      root.addEventListener('mousedown', start);
      root.addEventListener('touchstart', start, { passive: true });
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('mouseup', end);
      window.addEventListener('touchend', end);
      // Init to 50/50 — already handled by CSS clip-path default
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mawj-cart-premium"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-qty-change]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var lineId = btn.dataset.lineId;
        var input = document.querySelector('input[data-line-id="' + lineId + '"]');
        if (!input) return;
        var delta = parseInt(btn.dataset.qtyChange, 10);
        var newVal = Math.max(0, parseInt(input.value, 10) + delta);
        input.value = newVal;
        input.form.submit();
      });
    });
    document.querySelectorAll('.mcart__qty-input').forEach(function(input) {
      var t;
      input.addEventListener('input', function() {
        clearTimeout(t);
        t = setTimeout(function() { input.form.submit(); }, 800);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mawj-lander-hero-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.querySelector('.mlh');
    if (!sec) return;

    /* Image swap on shape selection */
    var heroImg = sec.querySelector('[data-hero-preview-image]');
    if (heroImg) {
      sec.querySelectorAll('.mawj-shape-tile').forEach(function (tile) {
        tile.addEventListener('click', function () {
          if (tile.dataset.img && heroImg.src !== tile.dataset.img) {
            heroImg.style.opacity = '0';
            setTimeout(function () {
              heroImg.src = tile.dataset.img;
              heroImg.style.opacity = '1';
            }, 180);
          }
        });
      });
    }

    /* Box add-on price refresh */
    var boxCheck = sec.querySelector('.mawj-box-toggle');
    var totalEl = sec.querySelector('[data-combined-price]');
    var activeTile = sec.querySelector('.mawj-shape-tile.is-active');
    var BASE = activeTile ? parseFloat(activeTile.dataset.price) : 150;
    var BOX = boxCheck ? parseFloat(boxCheck.dataset.boxPrice || 25) : 25;

    function refreshTotal() {
      var active = sec.querySelector('.mawj-shape-tile.is-active');
      BASE = active ? parseFloat(active.dataset.price) : BASE;
      var withBox = boxCheck && boxCheck.checked;
      if (totalEl) totalEl.innerHTML = '<bdi dir="ltr">' + (withBox ? BASE + BOX : BASE) + '</bdi> د.إ';
      var compareEl = sec.querySelector('[data-compare-display]');
      if (compareEl) {
        var cp = active ? (active.dataset.comparePrice || '') : '';
        compareEl.innerHTML = (cp && parseFloat(cp) > 0) ? '<bdi dir="ltr">' + cp + '</bdi> د.إ' : '';
      }
    }

    if (boxCheck) boxCheck.addEventListener('change', refreshTotal);
    sec.querySelectorAll('.mawj-shape-tile').forEach(function (tile) {
      tile.addEventListener('click', refreshTotal);
    });
    refreshTotal();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mawj-lv-closer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('lv-sticky');
    var order = document.getElementById('lv-order');
    if (!bar || !order || !('IntersectionObserver' in window)) return;
    bar.removeAttribute('hidden');
    new IntersectionObserver(function (entries) {
      // show the bar only when the order studio is NOT in view
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { threshold: 0.08 }).observe(order);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mawj-lv-order"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.getElementById('lv-order');
    if (!sec) return;
    var BASE = 150, BOX = 25, SECOND = 130;
    var img = document.getElementById('lvo-shape-img');
    var variantInput = document.getElementById('lvo-variant');
    var total = sec.querySelector('[data-combined-price]');
    var label = document.getElementById('lvo-atc-label');
    var boxToggle = sec.querySelector('.mawj-box-toggle');
    var secondToggle = sec.querySelector('.mawj-second-toggle');

    function fmt(n) { return '<bdi dir="ltr">' + n + '</bdi> د.إ'; }
    function refresh() {
      var withBox = boxToggle && boxToggle.checked;
      var withSecond = secondToggle && secondToggle.checked;
      var boxQty = withBox ? (withSecond ? 2 : 1) : 0;
      var sum = BASE + (withSecond ? SECOND : 0) + BOX * boxQty;
      if (total) total.innerHTML = fmt(sum);
      if (label) label.textContent = withSecond ? 'اطلب القطعتين — الدفع عند الاستلام'
        : withBox ? 'اطلب القطعة + الصندوق — الدفع عند الاستلام' : 'اطلب الآن — الدفع عند الاستلام';
    }
    if (secondToggle) secondToggle.addEventListener('change', refresh);
    sec.querySelectorAll('.lvo__shape').forEach(function (b) {
      b.addEventListener('click', function () {
        sec.querySelectorAll('.lvo__shape').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-active');
        b.setAttribute('aria-checked', 'true');
        variantInput.value = b.dataset.variant;
        if (img && b.dataset.img) { img.style.opacity = 0; setTimeout(function () { img.src = b.dataset.img; img.alt = 'تعليقة كريستال ' + b.dataset.name; img.style.opacity = 1; }, 180); }
      });
    });
    if (boxToggle) boxToggle.addEventListener('change', refresh);
    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mawj-mm-order"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sec = document.getElementById('mm-order');
    if (!sec) return;
    var BASE = 150, BOX = 25, SECOND = 130;
    var variantInput = document.getElementById('mmo-variant');
    var total = sec.querySelector('[data-combined-price]');
    var label = document.getElementById('mmo-atc-label');
    var boxToggle = sec.querySelector('.mawj-box-toggle');
    var secondToggle = sec.querySelector('.mawj-second-toggle');
    function refresh() {
      var withBox = boxToggle && boxToggle.checked;
      var withSecond = secondToggle && secondToggle.checked;
      var boxQty = withBox ? (withSecond ? 2 : 1) : 0;
      var sum = BASE + (withSecond ? SECOND : 0) + BOX * boxQty;
      if (total) total.innerHTML = '<bdi dir="ltr">' + sum + '</bdi> د.إ';
      if (label) label.textContent = withSecond ? 'اطلب القطعتين — الدفع عند الاستلام'
        : withBox ? 'اطلب القطعة + الصندوق — الدفع عند الاستلام' : 'اطلب الآن — الدفع عند الاستلام';
    }
    if (secondToggle) secondToggle.addEventListener('change', refresh);
    var shapeImg = document.getElementById('mmo-shape-img');
    sec.querySelectorAll('.mmo__row').forEach(function (b) {
      b.addEventListener('click', function () {
        sec.querySelectorAll('.mmo__row').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-checked', 'true');
        variantInput.value = b.dataset.variant;
        if (shapeImg && b.dataset.img) {
          shapeImg.style.opacity = '0';
          setTimeout(function () { shapeImg.src = b.dataset.img; shapeImg.style.opacity = '1'; }, 180);
        }
      });
    });
    if (boxToggle) boxToggle.addEventListener('change', refresh);
    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mawj-mm-peace"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.getElementById('mm-sticky');
    var order = document.getElementById('mm-order');
    if (!bar || !order || !('IntersectionObserver' in window)) return;
    bar.removeAttribute('hidden');
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { threshold: 0.08 }).observe(order);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mawj-process-premium"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-mawj-pp]');
    if (!section) return;

    var steps = section.querySelectorAll('.mawj-pp__step');
    var stepsContainer = section.querySelector('.mawj-pp__steps');
    var curvePath = section.querySelector('.mawj-pp__curve-path');

    // Set accurate dash length from actual path geometry
    if (curvePath) {
      var len = curvePath.getTotalLength ? curvePath.getTotalLength() : 900;
      curvePath.style.strokeDasharray = len;
      curvePath.style.strokeDashoffset = len;
    }

    if (!('IntersectionObserver' in window)) {
      steps.forEach(function (s) { s.classList.add('is-visible'); });
      if (curvePath) curvePath.style.strokeDashoffset = '0';
      return;
    }

    var stepObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          stepObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    steps.forEach(function (s) { stepObs.observe(s); });

    if (curvePath && stepsContainer) {
      var curveObs = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          curvePath.style.strokeDashoffset = '0';
          curveObs.disconnect();
        }
      }, { threshold: 0.1 });
      curveObs.observe(stepsContainer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mawj-product-main"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var slides = document.querySelectorAll('.mpdp__slide');
    var thumbs = document.querySelectorAll('.mpdp__thumb');
    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    var current = 0;

    function go(idx) {
      if (idx < 0) idx = slides.length - 1;
      if (idx >= slides.length) idx = 0;
      slides.forEach(function(s, i) { s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
      current = idx;
    }
    thumbs.forEach(function(t, i) { t.addEventListener('click', function() { go(i); }); });
    if (prev) prev.addEventListener('click', function() { go(current - 1); });
    if (next) next.addEventListener('click', function() { go(current + 1); });

    // Swipe support on mobile
    var main = document.querySelector('[data-gallery-main]');
    if (main) {
      var startX = 0, startT = 0;
      main.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startT = Date.now();
      }, { passive: true });
      main.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dt = Date.now() - startT;
        if (Math.abs(dx) > 40 && dt < 600) {
          // RTL-aware: swipe right (positive dx) means PREV
          go(dx > 0 ? current - 1 : current + 1);
        }
      }, { passive: true });
    }
  })();

  /* Box add-on: swap the displayed total when toggled, and add both the product
     and the box to the cart together on Add-to-Cart. */
  (function () {
    var addon = document.querySelector('[data-addon-input]');
    if (!addon) return;
    var priceEl = document.querySelector('.mpdp__price-current');
    var stickyEl = document.querySelector('.mpdp__sticky-price b');
    var base = addon.getAttribute('data-price-base');
    var combined = addon.getAttribute('data-price-combined');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function sync() {
      var t = addon.checked ? combined : base;
      if (priceEl) priceEl.textContent = t;
      if (stickyEl) stickyEl.textContent = t;
    }
    addon.addEventListener('change', sync);

    var PHOTO_PROP = 'properties[صورة العميل]';

    function bind(form) {
      if (!form) return;
      form.addEventListener('submit', function (e) {
        var needsBox = addon.checked;
        var ownPhoto = form.querySelector('.mpu__input');
        var pagePhoto = document.querySelector('.mpu__input[name="' + PHOTO_PROP + '"]');
        // Native single-item submit is fine when no box is selected and the form
        // either carries its own uploader or the page has none at all.
        if (!needsBox && (ownPhoto || !pagePhoto)) return;
        e.preventDefault();

        // Sticky form has no uploader — require the page photo before checkout
        if (!ownPhoto && pagePhoto && !(pagePhoto.files && pagePhoto.files[0])) {
          var mpu = pagePhoto.closest('.mpu');
          if (mpu) {
            mpu.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var err = mpu.querySelector('.mpu__error');
            if (err) { err.textContent = window.mawjStrings.photoRequired; err.hidden = false; }
          }
          return;
        }

        // Multipart FormData so the photo file + properties survive
        // (a JSON items[] payload silently drops File values)
        var fd = new FormData(form);
        if (!ownPhoto && pagePhoto && pagePhoto.files && pagePhoto.files[0]) {
          fd.set(PHOTO_PROP, pagePhoto.files[0]);
          var pageText = document.querySelector('.mpu__text-input');
          if (pageText && pageText.value.trim()) fd.set('properties[نص مع الصورة]', pageText.value.trim());
        }
        fetch(root + 'cart/add.js', { method: 'POST', body: fd })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            if (!needsBox) return null;
            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [
                { id: parseInt(addon.getAttribute('data-addon-variant'), 10), quantity: 1 }
              ] })
            }).then(function (rb) { if (!rb.ok) throw new Error('box add failed'); });
          })
          .then(function () { window.location = root + 'cart'; })
          .catch(function (err) { console.error('[Mawj] PDP add error:', err); });
      });
    }
    bind(document.querySelector('.mpdp__atc-form'));
    bind(document.querySelector('.mpdp__sticky-form'));
  })();

  /* ---- LED Colour Player ---- */
  (function () {
    var player = document.querySelector('[data-led-player]');
    var glow = document.querySelector('[data-led-glow]');
    if (!player || !glow) return;
    var swatches = Array.prototype.slice.call(player.querySelectorAll('.mawj-led__swatch'));
    var colorBtns = swatches.filter(function (s) { return s.getAttribute('data-led') !== 'off'; });
    var auto = null, idle = null, i = 0;

    function setColor(c, btn) {
      swatches.forEach(function (s) { s.classList.remove('is-active'); });
      if (btn) btn.classList.add('is-active');
      if (c === 'off') { glow.classList.remove('is-on'); glow.style.removeProperty('--led'); }
      else { glow.style.setProperty('--led', c); glow.classList.add('is-on'); }
    }
    function stopAuto() { if (auto) { clearInterval(auto); auto = null; } clearTimeout(idle); }
    function startAuto() {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !colorBtns.length) return;
      auto = setInterval(function () {
        i = (i + 1) % colorBtns.length;
        setColor(colorBtns[i].getAttribute('data-led'), colorBtns[i]);
      }, 1600);
    }

    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        stopAuto();
        setColor(s.getAttribute('data-led'), s);
      });
    });

    // gentle teaser: cycle colours after a beat; stop the moment the user taps a swatch
    idle = setTimeout(startAuto, 1400);
    player.addEventListener('pointerdown', stopAuto, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
